import { useContactFormContext } from 'components/contact/ContactForm';
import ContactSubmitButton from 'components/contact/ContactSubmitButton';
import useFetch from 'hooks/useFetch';
import { useRouter } from 'next/router';
import React from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { trackSubmitContactForm } from 'utils/ga';
import { removeBackslashes } from 'utils/string';
import {
  PusherPositions,
  usePusherContext,
} from '@seaweb/coral/components/Pusher';
import Toast, { ToastTypes } from '@seaweb/coral/components/Toast';

function ContactSubmitServer() {
  const { request, loading } = useFetch();
  const { cleanedData, onError, resetError } = useContactFormContext();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { push } = useRouter();
  const { push: pushCoral } = usePusherContext();

  const captchaHandler = async () => {
    if (!executeRecaptcha) {
      return;
    }

    const result = await executeRecaptcha('contact_us');
    return result;
  };

  const handleSave = async () => {
    try {
      const token = await captchaHandler();
      if (!token) throw new Error('No token');

      trackSubmitContactForm();

      await request('/api/hc/contact/', 'post', {
        ...cleanedData,
        email: removeBackslashes(cleanedData.email),
        token,
      });

      resetError();
      push('/contact/success');
    } catch (err) {
      pushCoral(<Toast type={ToastTypes.Fail}>Failed to submit</Toast>, {
        position: PusherPositions.MiddleCenter,
        duration: 1500,
      });
      onError(err);
    }
  };

  return cleanedData.type ? (
    <ContactSubmitButton onClick={handleSave} disabled={loading} />
  ) : null;
}

export default ContactSubmitServer;
